export default __webpack_public_path__ + "static/media/DISTRIBUCION_ITEM_ICON_3.b571385a.svg";